
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetPtype3 as ObiMosfetPtype3Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ptype-3.js';
 
 
 

 
 export const ObiMosfetPtype3 = createComponent({
   react: React,
   tagName: 'obi-mosfet-ptype-3',
   elementClass: ObiMosfetPtype3Element,
   events: {
     
   }
  });
 
 